export const Types = {
  LOGIN_DATA: 'LOGIN_DATA',
  LOGOUT: 'LOGOUT',
  ACTIVE_SETTING_DETAIL_NAVIGATION: 'ACTIVE_SETTING_DETAIL_NAVIGATION',
  ADD_USER_ALERT: 'ADD_USER_ALERT',
  DELETE_USER_ALERT: 'DELETE_USER_ALERT',
  IS_NOTIFICATION_ACTIVE: 'IS_NOTIFICATION_ACTIVE',
  ADD_SUPPLIER_ALERT: 'ADD_SUPPLIER_ALERT',
  UPDATE_SUPPLIER_ALERT: 'UPDATE_SUPPLIER_ALERT',
  ADD_PRODUCT_ALERT: 'ADD_PRODUCT_ALERT',
  UPDATE_PRODUCT_ALERT: 'UPDATE_PRODUCT_ALERT',
  UPDATE_INVENTORY_ITEM_ALERT: 'UPDATE_INVENTORY_ITEM_ALERT',
}
